module.exports = __webpack_public_path__ + "Roboto-Thin.c25fd8d00fd9f570545d.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Thin.eot
// module id = 55
// module chunks = 10